export class TenantSettingModel {
    InitialMessage: string;
    NameOfStore: string;
    EmailToUnit: string;
    TelephonNumberToUnit: string;
    PostalAddressToUnit: string;
    PostalCodeToUnit: string;
    ZipCodeToUnit: string;
    VisitingAddressToUnit: string;
    IntrusionAlarm: string;
}

export class TenantEmailSettingModel {
    Subject: string;
    Body: string;
    Foot: string;
}



// WEBPACK FOOTER //
// ./src/app/models/tenantSettingModel.ts